import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';
import DashboardLayout from 'layout/Dashboard';
import ProtectedRoutes from './ProtectedRoutes';
import DeveloperProtectedRoutes from './DeveloperProtectedRoutes';
import SuperAdminProtectedRoutes from './SuperAdminProtectedRoutes';

const Dashboard = Loadable(lazy(() => import('pages/dashboard')));
const Color = Loadable(lazy(() => import('pages/component-overview/color')));
const Typography = Loadable(lazy(() => import('pages/component-overview/typography')));
const Shadow = Loadable(lazy(() => import('pages/component-overview/shadows')));
const CardTablePage = Loadable(lazy(() => import('pages/card/CardTablePage')));
const UGCManagementPage = Loadable(lazy(() => import('pages/ugc/UGCManagementPage')));
const NewsletterPage = Loadable(lazy(() => import('pages/newsletter/NewsletterPage')));
const ActivityLogsPage = Loadable(lazy(() => import('pages/activitylog/ActivityLogsPage')));

const MainRoutes = {
  path: '/',
  element: <DashboardLayout />,
  children: [
    {
      path: 'dashboard',
      element: <Dashboard />
    },
    {
      path: 'typography',
      element: <Typography />
    },
    {
      path: 'color',
      element: <Color />
    },
    {
      path: 'shadow',
      element: <Shadow />
    },
    {
      path: 'kairos-card',
      element: (
        <ProtectedRoutes>
          <DeveloperProtectedRoutes>
            <CardTablePage />
          </DeveloperProtectedRoutes>
        </ProtectedRoutes>
      )
    },
    {
      path: 'ugc-submissions',
      element: (
        <ProtectedRoutes>
          <UGCManagementPage />
        </ProtectedRoutes>
      )
    },
    {
      path: 'newsletter-subscribers',
      element: (
        <ProtectedRoutes>
          <NewsletterPage />
        </ProtectedRoutes>
      )
    },
    {
      path: 'activity-logs',
      element: (
        <ProtectedRoutes>
          <SuperAdminProtectedRoutes>
            <ActivityLogsPage />
          </SuperAdminProtectedRoutes>
        </ProtectedRoutes>
      )
    }
  ]
};

export default MainRoutes;
